import { useCallback } from 'react'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'

// full navigation, so GetServerSideProps and react server components re run.
// for a URL only update, use useShallowRouterReplace's excludedKeys instead.
export const useRemoveQueryString = () => {
  const router = useSegwayRouter()

  return useCallback(
    async (queryString: string): Promise<unknown> => {
      const url = new URL(window.location.href)
      if (!url.searchParams.has(queryString)) return false

      url.searchParams.delete(queryString)
      return router.replace(`${url.pathname}${url.search}`)
    },
    [router],
  )
}
